module.exports = __webpack_public_path__ + "static/media/image03.0605b370.png";